import React, { useState } from "react";
import { url } from "../lib/api";

const AuthForm = ({ setToken, setProfile }) => {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({
    username: "",
    password: "",
    confirm_password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (mode === "register") {
        if (form.password !== form.confirm_password) {
          setError("Passwords do not match");
          setLoading(false);
          return;
        }
        const res = await fetch(url("/register"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });
        if (!res.ok) throw new Error("Registration failed");
        // Auto-login after register
      }
      // Login
      const res = await fetch(url("/login"), {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          username: form.username,
          password: form.password,
        }),
      });
      if (!res.ok) throw new Error("Login failed");
      const data = await res.json();
      setToken(data.access_token);
      localStorage.setItem("jwt_token", data.access_token);
      // Fetch profile
      const profileRes = await fetch(url("/profile"), {
        headers: { Authorization: `Bearer ${data.access_token}` },
      });
      if (profileRes.ok) {
        const profile = await profileRes.json();
        setProfile(profile);
        localStorage.setItem("user_profile", JSON.stringify(profile));
      }
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-200 via-green-100 to-blue-400 py-10">
      <div className="bg-white/90 rounded-3xl shadow-2xl p-10 max-w-md w-full border-2 border-blue-200 animate-fade-in">
        <div className="flex flex-col items-center mb-6">
          <span className="text-5xl mb-2">
            {mode === "login" ? "🔐" : "📝"}
          </span>
          <h2 className="text-3xl font-extrabold mb-1 text-blue-700 drop-shadow text-center tracking-tight">
            {mode === "login" ? "Welcome Back!" : "Create Account"}
          </h2>
          <p className="text-gray-600 text-center text-base font-medium">
            {mode === "login"
              ? "Sign in to your nutrition dashboard"
              : "Register to get personalized nutrition advice"}
          </p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <input
            type="text"
            name="username"
            placeholder="Username"
            value={form.username}
            onChange={handleChange}
            className="border-2 border-blue-300 rounded-xl px-5 py-3 focus:outline-none focus:ring-2 focus:ring-green-300 text-lg bg-white shadow"
            required
            autoComplete="username"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            className="border-2 border-blue-300 rounded-xl px-5 py-3 focus:outline-none focus:ring-2 focus:ring-green-300 text-lg bg-white shadow"
            required
            autoComplete={
              mode === "login" ? "current-password" : "new-password"
            }
          />
          {mode === "register" && (
            <input
              type="password"
              name="confirm_password"
              placeholder="Confirm Password"
              value={form.confirm_password}
              onChange={handleChange}
              className="border-2 border-blue-300 rounded-xl px-5 py-3 focus:outline-none focus:ring-2 focus:ring-green-300 text-lg bg-white shadow"
              required
              autoComplete="new-password"
            />
          )}
          {error && (
            <div className="text-red-600 text-sm text-center font-semibold">
              {error}
            </div>
          )}
          <button
            type="submit"
            className="bg-gradient-to-r from-green-400 to-blue-500 text-white px-7 py-3 rounded-2xl font-bold shadow-lg hover:scale-105 transition-transform text-lg"
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <span className="animate-spin inline-block w-5 h-5 border-2 border-t-2 border-blue-400 border-t-transparent rounded-full"></span>
                Please wait...
              </span>
            ) : mode === "login" ? (
              "Login"
            ) : (
              "Register"
            )}
          </button>
        </form>
        <div className="mt-6 text-center">
          {mode === "login" ? (
            <>
              <span className="text-gray-700">Don't have an account?</span>{" "}
              <button
                className="text-blue-600 underline font-bold hover:text-blue-800 transition"
                onClick={() => setMode("register")}
              >
                Register
              </button>
            </>
          ) : (
            <>
              <span className="text-gray-700">Already have an account?</span>{" "}
              <button
                className="text-blue-600 underline font-bold hover:text-blue-800 transition"
                onClick={() => setMode("login")}
              >
                Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
